import { MailLog } from "hooks/useMails";

// Keys = mail types sent by functions (functions/src/helpers/mails.ts MAILS_TYPES)
export const MAIL_TYPES: Record<string, string> = {
  spot: "Potwierdzenie spot",
  "fixed-rate": "Potwierdzenie stałego kursu",
  order: "Zlecenie oczekujące",
  confirmation: "Potwierdzenie rozliczenia",
  settlement: "Rozliczenie",
  prolong: "Prolongata",
  "margin-call": "Wezwanie do depozytu",
  "global-margin-call": "Globalne wezwanie do depozytu",
  "final-notice": "Ponowne wezwanie do depozytu",
  agreement: "Umowa",
};

export const mailTypeLabel = (type: string) => MAIL_TYPES[type] ?? type;

export const filterMails = (
  mails: MailLog[],
  { status, type, query }: { status?: string; type?: string; query?: string }
) => {
  const text = query?.trim().toLowerCase();
  return mails.filter(
    (mail) =>
      (!status || mail.status === status) &&
      (!type || mail.type === type) &&
      (!text ||
        [mail.subject, ...mail.to, ...mail.cc, mail.company?.name ?? ""].some((value) =>
          value.toLowerCase().includes(text)
        ))
  );
};
